import React from 'react';

import {getPublicStandards} from 'api/standards';
import {SelectAsyncBase} from 'components/Forms/FormBases';

SelectPublicStandard.defaultProps = {
  placeholder: 'Select a Standard',
  isClearable: true,
  cacheOptions: true,
  defaultOptions: true,
  onChange: () => {},
  getOptionLabel: (option) => option.standards_name,
  getOptionValue: (option) => option.standards_id,
};

function SelectPublicStandard(props) {
  const {value, ...rest} = props;

  async function getOptions(inputValue) {
    try {
      const {data} = await getPublicStandards({search: inputValue});
      return data;
    } catch (error) {
      return [];
    }
  }

  return <SelectAsyncBase loadOptions={getOptions} {...rest} />;
}

export default SelectPublicStandard;
